import { html } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { config } from '../config.js';
import renderFooter from './partials/footer.js';

export default function renderErrorPageTemplate() {
  return html`
    <div id="megamenu" class="mm-header">
      <div class="mm-top" data-hide-when-sticky="true">
        <div class="mm-container">
          <ul class="mm-nav">
            <li class="mm-nav__item">
              <a href="https://orange.sk" class="mm-link mm-link--white mm-top__link">
                ísť na Orange.sk
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div role="main" class="vertical-stretch">
      <div class="section">
        <div class="container">
          <div class="grid align-items-center">
            <div class="grid__col--md-6 grid__col--lg-5 grid__col--xl-4 mb-medium mb-md-none">
              <h2 class="h1">Niečo sa pokazilo</h2>
              <p class="mb-md-small">
                Jedno koliesko v našom systéme sa zaseklo. Náš špecialista to už opravuje.
              </p>
              <p class="mb-large mb-md-xlarge bold">Skúste to, prosím, neskôr.</p>
              <div class="buttons buttons--stack-on-xs">
                <a href=${config.basePath} class="btn btn--primary">Skúsiť znova</a>
                <a href="https://orange.sk" class="btn">Prejsť na Orange.sk</a>
              </div>
            </div>
            <div class="grid__col--1 grid__col--sm-3 grid__col--md-1 grid__col--lg-2"></div>
            <div class="grid__col--10 grid__col--sm-6 grid__col--md-5 grid__col--lg-4">
              <img
                class="img"
                src="assets/images/working-man-with-error-screen.svg"
                alt="Muž pracujúci pred obrazovkou s chybou"
                role="presentation"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section bg-gray vertical-stretch"></div>
    </div>
    <footer>${renderFooter()}</footer>
  `;
}
